<template>
	<o-section title="Ajout d'une nouvelle qualification">
		<div class="form flex fd-c g-sm">
			<o-select
				v-model="setup.newUserProSkill"
				autofocus
				display-key="label"
				track-key="code"
				label="Qualification"
				searchable
				:options="setup.skillOptions"/>

			<div class="flex g-xs">
				<o-button
					block
					color="danger"
					outline
					@click="_modal?.close()">
					Annuler
				</o-button>
				<o-button
					block
					color="success"
					@click="setup.addUserProSkillAsync()">
					Ajouter
				</o-button>
			</div>
		</div>
	</o-section>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import UserProfileProSkillAsideNewSetupService from '@/setup/user-profile/UserProfileProSkillAsideNewSetupService';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(UserProfileProSkillAsideNewSetupService.props);
const setup = new UserProfileProSkillAsideNewSetupService(props, _modal);
</script>
